const Caution = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16.573 16.528">
      <g id="Group_44733" transform="translate(-0.713 -1.972)">
        <path id="Polygon_1"
              d="M7.211,3.578a2,2,0,0,1,3.578,0l5.764,11.528A2,2,0,0,1,14.764,18H3.236a2,2,0,0,1-1.789-2.894Z"
              transform="translate(0)" fill="none" stroke="#FFC700" strokeWidth="1"/>
        <g id="Group_16644" transform="translate(8.417 10.209)">
          <g id="Group_16643">
            <path id="Path_56858"
                  d="M236.792,214.33a.788.788,0,0,1,.792.784v5.048a.792.792,0,0,1-1.583,0v-5.048A.788.788,0,0,1,236.792,214.33Z"
                  transform="translate(-236 -214.33)" fill="#FFC700"/>
          </g>
        </g>
        <g id="Group_16646" transform="translate(8.417 6.89)">
          <g id="Group_16645">
            <ellipse id="Ellipse_926" cx="0.792" cy="0.828" rx="0.792" ry="0.828" fill="#FFC700"/>
          </g>
        </g>
      </g>
    </svg>
  );
}

export default Caution;